import Footer from 'components/Footers/Footer'
import Navbar from 'components/Navbars/IndexNavbar'
import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BASE_URL from 'components/BaseUrl/apiConfig';

const Verification = () => {

    const history = useHistory();

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const verificationToken = urlSearchParams.get('token');

        if (verificationToken) {
            fetch(`${BASE_URL}/api/Users/VerifyToken?token=${verificationToken}`)
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        // Display success message
                        Swal.fire({
                            icon: 'success',
                            title: 'Verification Successful',
                            text: data.msg,
                        });
                    } else {
                        // Display error message
                        Swal.fire({
                            icon: 'error',
                            title: 'Something went wrong.',
                            text: 'Please insert registered email and try again later.',
                        });
                    }
                })
                .catch(error => {
                    // Display error message for network or other errors
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'An error occurred during verification.',
                    });
                });
        }
    }, []);

    const goTobuttonClick = () => {
        // Navigate to the login page
        history.push('/login');
    };


    return (
        <>
            <Navbar />
            <div className='cust-div'>
                <div className=" justify-between items-center p-3">
                    <h1 className="text-2xl uppercase font-bold">Email Verification</h1>

                    <button
                        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mt-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={goTobuttonClick}
                    >
                        Go TO Sign In
                    </button>

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Verification
